import { getCookie } from "@/utils/cookieUtils";

export function checkAuthenticationStatus() {
  try {
    const token = getCookie("token");
    const exp = getCookie("exp");

    if (!token || !exp) return false;

    const expTimestamp = parseInt(exp);
    if (isNaN(expTimestamp)) return false;

    const expirationTime = new Date(expTimestamp * 1000);
    return expirationTime > new Date();
  } catch (error) {
    console.error("Ошибка проверки статуса аутентификации:", error);
    return false;
  }
}
